const ArrayWithExtraFields = require('relevant-shared/misc/arrayWithExtraFields');
const { approxComboCount } = require('./utils');

/** Class that represents the dimensions in a single report used when updating HBA-data from adserver API-data.
 * It will contain GranularDimension instances and .id must be unique within a GranularDimensionSet. */
class GranularDimensionArr extends ArrayWithExtraFields {
	onConstructed(id, dims) {
		this.id = id;
		this.setElements(dims);
	}

	approxComboCount() {
		return approxComboCount(this);
	}
}

module.exports = GranularDimensionArr;
